import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import {
  ActualMatch,
  Background,
  Container,
  DataContainer,
  Divider,
  MatchData,
  MatchIcon,
  Rank,
  RankData,
  RankIcon,
  TotalMatch,
} from './styles';

function FortniteSimple({ data, styles }) {
  return (
    <>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <Container>
        <Background
          width="561"
          height="81"
          viewBox="0 0 561 81"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M245.51 80.3907H0V0H292.645L245.51 80.3907Z"
            fill={styles.match.background}
          />
          <path
            d="M315.49 -7.00896e-05L561 -9.15527e-05L561 80.3906L268.355 80.3907L315.49 -7.00896e-05Z"
            fill={styles.rank.background}
          />
        </Background>
        <DataContainer>
          <MatchIcon>
            <svg
              width="63"
              height="47"
              viewBox="0 0 63 47"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M62.9139 37.2307L59.3397 11.515C58.4215 4.90143 52.8798 0 46.3544 0H16.6456C10.1202 0 4.57851 4.90143 3.66036 11.515L0.0861301 37.2307C-0.635274 42.4007 3.26687 47 8.34949 47C10.5793 47 12.6779 46.0936 14.2519 44.4821L21.6627 36.9286H41.3373L48.7153 44.4821C50.2893 46.0936 52.4207 47 54.6177 47C59.7331 47 63.6353 42.4007 62.9139 37.2307ZM28.2209 20.1429H21.6627V26.8571H18.3836V20.1429H11.8253V16.7857H18.3836V10.0714H21.6627V16.7857H28.2209V20.1429ZM41.3373 16.7857C39.5338 16.7857 38.0582 15.275 38.0582 13.4286C38.0582 11.5821 39.5338 10.0714 41.3373 10.0714C43.1409 10.0714 44.6165 11.5821 44.6165 13.4286C44.6165 15.275 43.1409 16.7857 41.3373 16.7857ZM47.8956 26.8571C46.0921 26.8571 44.6165 25.3464 44.6165 23.5C44.6165 21.6536 46.0921 20.1429 47.8956 20.1429C49.6991 20.1429 51.1747 21.6536 51.1747 23.5C51.1747 25.3464 49.6991 26.8571 47.8956 26.8571Z"
                fill={styles.match.color}
              />
            </svg>
          </MatchIcon>
          <MatchData>
            <ActualMatch style={{ color: styles.match.color }}>
              {data.actualMatch}
            </ActualMatch>
            <TotalMatch style={{ color: styles.match.color }}>/</TotalMatch>
            <TotalMatch style={{ color: styles.match.color }}>
              {data.totalMatch}
            </TotalMatch>
          </MatchData>
          <Divider />
          <RankIcon>
            <svg
              width="46"
              height="47"
              viewBox="0 0 46 47"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.977 0C10.281 0 0 10.528 0 23.5C0 36.472 10.281 47 22.977 47C35.696 47 46 36.472 46 23.5C46 10.528 35.696 0 22.977 0ZM32.729 37.6L23 31.6075L13.271 37.6L15.847 26.2965L7.268 18.706L18.584 17.719L23 7.05L27.416 17.6955L38.732 18.6825L30.153 26.273L32.729 37.6Z"
                fill={styles.rank.color}
              />
            </svg>
          </RankIcon>
          <RankData>
            <Rank style={{ color: styles.rank.color }}>{data.rank}</Rank>
          </RankData>
        </DataContainer>
      </Container>
    </>
  );
}

FortniteSimple.propTypes = {
  data: PropTypes.shape({
    actualMatch: PropTypes.string,
    rank: PropTypes.string,
    totalMatch: PropTypes.string,
  }),
  styles: PropTypes.shape({
    match: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
    }),
    rank: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
    }),
  }),
};

FortniteSimple.defaultProps = {
  data: {
    actualMatch: '1',
    rank: '325',
    totalMatch: '10',
  },
  styles: {
    match: {
      background: '#6DA0F0',
      color: '#ffffff',
    },
    rank: {
      background: '#3A6EBD',
      color: '#ffffff',
    },
  },
};

export default FortniteSimple;
